<template>
    <v-main class="white">

      <div class="mt-12 mb-5 pa-3 m-auto" style="max-width:600px;">
        <h1 class="display-2 text-center font-weight-thin">CORONA ART GALLERY</h1>
        <!--<h3 class="title font-weight-thin black--text px-5 mt-8 text-center" style="margin:auto;">{{$t('welcome_subline')}}</h3>-->
      </div>

        <!-- mapHub -->
        <!--<iframe :width="`${bgWidth}px`" :height="`${bgHeight*0.8}px`" src="https://maphub.net/embed/99071?button=1&legend=0&panel=0&panel_closed=1&geolocation=1" frameborder="0"></iframe>-->
        <!-- Own map -->
        
        
        <HLMap 
            v-if="geoData"
            class=""
            :height="`${mapHeight}px`"
            :singleMarkerMode="false"
            :initialZoom="2"
            :maxMapZoom="20"
            :minMapZoom="2"
            :items="geoData.features"
            draggable
            :showLayerSelector="false"
            :showZoom="true"
            :width="`${bgWidth}px`"
          />
        
          <div v-if="true" class="mt-12 mb-5 pa-3 m-auto" style="max-width:600px;">
            <h3 class="title font-weight-light black--text px-5 mt-8 text-center" style="margin:auto;" v-html="$t('welcome_take_part_text')"></h3>
          </div>

    </v-main>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {locationMixin} from '@/utils/location-mixin'
import {apiMixin} from '@/utils/api-mixin'
import HLMap from '@/components/HLMap.vue'
import jsonGeoData from '@/assets/jsonGeoData.json';
export default {
  components:{
    HLMap
  },
  mixins: [layoutMixin,apiMixin,locationMixin],
  data(){
    return{
      geoData:jsonGeoData
    }
  },
  computed: {
    mapHeight(){
      let fac=(this.isSmAndUpDevice)?0.7:0.8;
      return this.bgHeight*fac;
    }
  },
  methods:{
  },
  mounted(){

  }
}
</script>

<style>

.v-dialog__content.v-dialog__content--active, .v-overlay.v-overlay--active{
  z-index:999999!important;
}
</style>
